import AddNewEmployee from './addNewEmployee';
export default AddNewEmployee;